import { useMutation } from '@apollo/client';
import { graphql } from '@app/graphql/types';

export const QUERY = graphql(`
    mutation CompleteOnlineOrderReview($onlineOrderID: ID!) {
        storefront_onlineOrder_review_complete(onlineOrderID: $onlineOrderID)
    }
`);

export function useOnlineOrderReviewComplete() {
  return useMutation(QUERY, {refetchQueries: ['OnlineOrderDetailPage']});
} 